import { forwardRef } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import "../../style/common/ConfirmCounter.scss";
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import { Box } from "@mui/material";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ConfirmCounter(props) {
    const {
        onClose,
        open,
        showTitle = true,
        width = "auto",
        height = "auto",
        onConfirm,
        CounterProps,
        onSelect,
        ...other
    } = props;
    const handleOk = () => {
        onClose();
    };

    return (
        <Dialog
            sx={{
                "& .MuiDialog-paper": {
                    width: width,
                    height: height,
                    borderRadius: "10px",
                    overflow: 'visible',
                },
            }}
            maxWidth="xs"
            TransitionComponent={Transition}
            open={open}
            {...other}
        >
            {showTitle && <DialogTitle>{'Select Working Counter'}</DialogTitle>}
            <DialogContent
                sx={{
                    overflow: 'visible', // Set overflow to visible
                }}
                dividers>
                {/* <Box sx={{marginY:'10px'}}>Select Counter</Box> */}
                <MultiSelectDropDown
                    {...CounterProps()}
                    onSelect={onSelect}
                />
            </DialogContent>
            <DialogActions>
                <div className="dialog-confirm1">
                    <Button onClick={handleOk}>OK</Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

ConfirmCounter.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default ConfirmCounter;
